import { Types } from "@grandvisionhq/graphql";
import { getLocalizedString, getLocalizedStrings, isNil } from "@grandvisionhq/utils";
import { toBaseLineItem } from "./base-line-item.js";
const toEyeSide = (eyeSide) => {
  switch (eyeSide) {
    case Types.EyeSide.LEFT:
      return "left";
    case Types.EyeSide.RIGHT:
      return "right";
    case Types.EyeSide.BOTH:
      return "both";
  }
};
const toEyeSideLabelKey = (eyeSide) => {
  switch (eyeSide) {
    case Types.EyeSide.LEFT:
      return "products.contactLenses.leftEye";
    case Types.EyeSide.RIGHT:
      return "products.contactLenses.rightEye";
    case Types.EyeSide.BOTH:
      return void 0;
  }
};
const toEyePrescription = (prescription) => {
  return {
    addition: isNil(prescription?.addition) ? null : prescription.addition,
    axis: isNil(prescription?.axis) ? null : prescription.axis,
    baseCurve: isNil(prescription?.baseCurve) ? null : prescription.baseCurve,
    cylinder: isNil(prescription?.cylinder) ? null : prescription.cylinder,
    diameter: isNil(prescription?.diameter) ? null : prescription.diameter,
    dominance: isNil(prescription?.dominance) ? null : prescription.dominance,
    power: isNil(prescription?.power) ? null : prescription.power
  };
};
const toContactLensesOrderLineItem = (orderLineItem, intl, options = {}) => {
  const { eyeSide, prescription } = orderLineItem;
  const { boxQuantity, colors, replacementFrequency } = orderLineItem.product;
  const eyeSideLabelKey = toEyeSideLabelKey(eyeSide);
  const replacementFrequencyLabel = getLocalizedString(replacementFrequency, intl.locale);
  const colorValues = getLocalizedStrings(colors, intl.locale);
  const colorLabel = `${intl.getLabel("products.lensColor")}: ${colorValues.join(", ")}`;
  const unit = intl.getLabel("products.unit.contactLenses");
  const eyeSideLabel = eyeSideLabelKey ? intl.getLabel(eyeSideLabelKey) : void 0;
  let perBox = intl.getLabel("products.perBox");
  perBox = eyeSideLabelKey ? `${perBox},` : perBox;
  const subtitle = [boxQuantity, replacementFrequencyLabel, unit, perBox, eyeSideLabel].filter(Boolean).join(" ");
  return {
    ...toBaseLineItem(orderLineItem, intl, options),
    type: "CONTACT_LENSES",
    productType: "contact-lenses",
    subtitle,
    eyeSide: toEyeSide(eyeSide),
    prescription: toEyePrescription(prescription),
    isSubscription: orderLineItem.isSubscription,
    subscriptionDetails: orderLineItem.subscriptionDetails || void 0,
    additionalInfo: colorValues.length ? [colorLabel] : void 0
  };
};
export {
  toContactLensesOrderLineItem
};
//# sourceMappingURL=contact-lenses-line-item.js.map
